module.exports = __webpack_public_path__ + "static/media/9pic.4b45d621.jpg";